import $ from 'jquery';
import moment from 'moment'
import Litepicker from 'litepicker';

var lp=null;
// input element for start date
const element = document.getElementById('date-picker');
// input element for end date
const elementEnd = document.getElementById('date-picker__end');
// start date helper, selected start date element for user to see
const dateSelectedValueStart = document.getElementById('date-start');
// end date helper, selected end date element for user to see
const dateSelectedValueEnd = document.getElementById('date-end');

/**
 * When the date range is selected, set the helper elements and
 * trigger the form submit event
 *
 * @param string one date of the first date in the selected range
 * @param string two date of the last date in the selected range
 */
const onSelect = (one, two) => {
    const dateOne = moment(one);
    const dateTwo = moment(two);
    dateSelectedValueStart.textContent = dateOne.format('MM/DD/YYYY');
    dateSelectedValueEnd.textContent = dateTwo.format('MM/DD/YYYY');
    $(element).closest('form').trigger('submit');
};

/**
 * Get todays date
 * @param separator
 * @returns {string}
 */
function getToday() {
    const todayDate = moment();

    return todayDate.format('YYYY-MM-DD');
}
if(element!==null){
    
    const opts = {
        element,
        elementEnd,
        singleMode: false,
        inlineMode: true,
        firstDay: 0,
        minDate: getToday(),
        onSelect,
    };
    lp = new Litepicker(opts);
}
export default lp;
